import { Icon } from "@vp/swan";
import React from "react";
import { ContentfulCloudinaryImageComponent, CTACloudinaryImage } from "../types/ContentfulTypes";

type IconVariant = "primary" | "secondary";

export interface CloudinaryIconProps {
  variant?: IconVariant;
  image?: ContentfulCloudinaryImageComponent<CTACloudinaryImage>;
}

export const CloudinaryIcon = (props: CloudinaryIconProps) => {
  const cloudinaryImage = props.image?.cloudinaryImage;
  const imgSrc = getImgSrc(props.variant, props.image);
  const darkMode = props.variant === "primary";
  return (
    <Icon
      darkMode={darkMode}
      src={imgSrc}
      alt={props.image?.altTextOverride || cloudinaryImage?.alt || ""}
      marginRight={"3"}
    />
  );
};

const getImgSrc = (
  variant: IconVariant | undefined,
  image: ContentfulCloudinaryImageComponent<CTACloudinaryImage> | undefined
) => {
  let imgSrc: string | undefined;
  const cloudinaryImage = image?.cloudinaryImage;
  if (variant) {
    if (variant === "primary") {
      imgSrc = cloudinaryImage?.iconPrimaryUrl;
    } else if (variant === "secondary") {
      imgSrc = cloudinaryImage?.iconSecondaryUrl;
    }
  }

  if (!imgSrc) {
    imgSrc = cloudinaryImage?.transformedCloudinaryUrl;
  }
  return imgSrc;
};
